// @core/api/endpoints/authn/initiate_oauth2_flow.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  InitiateOAuth2FlowRequest,
  InitiateOAuth2FlowResponse,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Initiate external OAuth2 flow
 * Generates an authorization URL for redirecting users to an external OAuth2 provider for authentication. Returns the URL with proper state and CSRF protection.
 */
export async function InitiateOAuth2Flow(
  data: InitiateOAuth2FlowRequest,
  options?: RequestOptions
): Promise<InitiateOAuth2FlowResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/oauth2/external/initiate`;
  const requestOptions = options;
  return client.post<InitiateOAuth2FlowResponse>(requestPath, data, requestOptions);
}
